
import { IdeasList } from '../ideasList/ideasList.component'
import { TopEmployeesLeaderboard } from '../topEmployeesLeaderboard/topEmployeesLeaderboard'
import { TopIdeasList } from '../topIdeasList/topIdeasList'
import logo from '../../assets/images/new-logo.png'
import starLogo from "../../assets/images/star-sm.png"
import silverLogo from "../../assets/images/silver.png"
import goldLogo from "../../assets/images/gold.png"
import bronzeLogo from "../../assets/images/bronze.png"
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
export const LeaderBoardStats = () => {
    const userName = useSelector(state => state.user.empName)
    const [currenttab, setCurrentTab] = useState(1)
    const [allTimeWinner, setAllTimeWinner] = useState("")
    const [first, setFirst] = useState("")
    const [second, setSecond] = useState("")
    const [third, setThird] = useState("")

    useEffect(() => {
        if (currenttab == 1) {
            setAllTimeWinner("IAFA")
            setFirst("IAFA")
            setSecond("TC")
            setThird("D&D")
        }
        if (currenttab == 2) {
            setAllTimeWinner("Hyderabad")
            setFirst("Hyderabad")
            setSecond("Bengaluru")
            setThird("Gurugram")
        }
        if (currenttab == 3) {
            setAllTimeWinner("Manish Laligam Sundaresan")
            setFirst("Manish Laligam Sundaresan")
            setSecond("Praveen Kokku")
            setThird("Ranjan Kumar Sinha")
        }
        if (currenttab == 4) {
            setAllTimeWinner("Clients and Pursuits")
            setFirst("Clients and Pursuits")
            setSecond("Service Delivery")
            setThird("People and Change")
        }
    }, [currenttab])


    return (
        <>
            <div className="app-content content">
                <div className="content-overlay" />
                <div className="header-navbar-shadow">
                    <img
                        src={logo}
                        className="d-none d-lg-block"
                        alt="img"
                    />
                </div>
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <div className="card">
                                    <div className="card-body p-0">
                                        <div className="row">
                                            <div className="col-8 col-lg-9">
                                                <div className="py-1 px-2">
                                                    <h2 className="text-uppercase mb-5">
                                                        Hello, <span className="star-orange">{userName}</span>
                                                    </h2>
                                                    <p className="font-lato mb-0">
                                                        Welcome back to the leaderboard
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-4 col-lg-3 text-right">
                                                <img
                                                    src={starLogo}
                                                    alt="img"
                                                    className="rounded-15 w-100 mh-80p obj-fit"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-3">
                                <div className="card">
                                    <div className="card-body mh-80p">
                                        <div className="media">
                                            <div className="mr-2 font-30">
                                                <i className="fas fa-chart-line" />
                                            </div>
                                            <div className="media-body my-auto">
                                                <h4 className="text-uppercase font-lato mb-0">10,000</h4>
                                                <p className="mb-0 font-lato font-10 star-orange">
                                                    Total members
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-3">
                                <div className="card">
                                    <div className="card-body mh-80p">
                                        <div className="media">
                                            <div className="starshot-ring mr-1">
                                                <div className="avatar">
                                                    <div className="text-icon font-lato">C</div>
                                                </div>
                                            </div>
                                            <div className="media-body my-auto">
                                                <h4 className="text-uppercase mb-0">{allTimeWinner}</h4>
                                                <p className="mb-0 font-lato font-10 star-orange">
                                                    All time winner
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <ul className="nav nav-pills text-uppercase bg-dark-star rounded-10">
                                    <li className="nav-item" onClick={() => setCurrentTab(1)}>
                                        <a className={"nav-link " + (currenttab == 1 && "active")}>
                                            Solution
                                        </a>
                                    </li>
                                    <li className="nav-item" onClick={() => setCurrentTab(2)}>
                                        <a className={"nav-link " + (currenttab == 2 && "active")}>
                                            Office
                                        </a>
                                    </li>
                                    <li className="nav-item" onClick={() => setCurrentTab(3)}>
                                        <a className={"nav-link " + (currenttab == 3 && "active")}>
                                            MD
                                        </a>
                                    </li>
                                    <li className="nav-item" onClick={() => setCurrentTab(4)}>
                                        <a className={"nav-link " + (currenttab == 4 && "active")}>
                                            Category of Innovation
                                        </a>
                                    </li>
                                </ul>
                                <div className="row">
                                    <div className="col-12 col-lg-12">
                                        <div className="card card-congratulation-medal">
                                            <div className="card-body">
                                                <div className="d-flex">
                                                    <p className="text-orange font-50 mr-2 text-center text-uppercase">
                                                        01
                                                        <br />
                                                        <span className="font-20 text-white">Rank</span>
                                                    </p>
                                                    <h4>{first}</h4>
                                                </div>
                                                <table className="table table-sm bg-grad rounded-10 text-white w-70">
                                                    <tbody>
                                                        <tr>
                                                            <th>Idea Score</th>
                                                            <th>Engagement Score</th>
                                                            
                                                        </tr>
                                                        <tr>
                                                            <td>88</td>
                                                            <td>12,00</td>
                                                          
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <img
                                                    src={goldLogo}
                                                    className="congratulation-medal w-100p"
                                                    alt="img"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="card">
                                            <div className="card-body py-0">
                                                <div className="text-center mb-1">
                                                    <img
                                                        src={silverLogo}
                                                        className="w-70p"
                                                        alt="img"
                                                    />
                                                </div>
                                                <div className="d-flex">
                                                    <p className="text-orange font-50 mr-2 text-center text-uppercase">
                                                        02
                                                        <br />
                                                        <span className="font-20 text-white">Rank</span>
                                                    </p>
                                                    <h4>{second}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="card">
                                            <div className="card-body py-0">
                                                <div className="text-center mb-1">
                                                    <img
                                                        src={bronzeLogo}
                                                        className="w-70p"
                                                        alt="img"
                                                    />
                                                </div>
                                                <div className="d-flex">
                                                    <p className="text-orange font-50 mr-2 text-center text-uppercase">
                                                        03
                                                        <br />
                                                        <span className="font-20 text-white">Rank</span>
                                                    </p>
                                                    <h4>{third}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {currenttab == 1 &&
                                <div className="col-12 col-lg-6">
                                    <div className="table-responsive">
                                        <table className="table idea-table font-lato font-12">
                                            <tbody>
                                                <tr>
                                                    <th>Rank</th>
                                                    <th>Name</th>
                                                    <th>Idea Score</th>
                                                    <th>Engagement Score</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        4<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>BP</td>
                                                    <td>83</td>
                                                    <td>15,00</td>
                                                </tr>
                                                
                                               
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            }
                            {currenttab == 2 &&
                                <div className="col-12 col-lg-6">
                                    <div className="table-responsive">
                                        <table className="table idea-table font-lato font-12">
                                            <tbody>
                                                <tr>
                                                    <th>Rank</th>
                                                    <th>Name</th>
                                                    <th>Idea Score</th>
                                                    <th>Engagement Score</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        4<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>Mumbai</td>
                                                    <td>83</td>
                                                    <td>15,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        5<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Kolkata</td>
                                                    <td>88</td>
                                                    <td>12,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        6<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>Kuwait City</td>
                                                    <td>85</td>
                                                    <td>11,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        7<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Muscat</td>
                                                    <td>90</td>
                                                    <td>10,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        8<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Riyadh</td>
                                                    <td>81</td>
                                                    <td>9,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        9<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Abu Dhabi</td>
                                                    <td>88</td>
                                                    <td>8,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        10
                                                        <i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Duba</td>
                                                    <td>70</td>
                                                    <td>7,00</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            }
                            {currenttab == 3 &&
                                <div className="col-12 col-lg-6">
                                    <div className="table-responsive">
                                        <table className="table idea-table font-lato font-12">
                                            <tbody>
                                                <tr>
                                                    <th>Rank</th>
                                                    <th>Name</th>
                                                    <th>Idea Score</th>
                                                    <th>Engagement Score</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        4<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>Adib Mohammed Ibrahim</td>
                                                    <td>83</td>
                                                    <td>15,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        5<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Rajagopal Parthasarathy</td>
                                                    <td>88</td>
                                                    <td>12,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        6<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>Rustom Sleiman</td>
                                                    <td>85</td>
                                                    <td>11,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        7<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Amit Ray</td>
                                                    <td>90</td>
                                                    <td>10,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        8<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Mohamed Abdallah El Saied Al Bouhy</td>
                                                    <td>81</td>
                                                    <td>9,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        9<i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Ahmed Mohamed Ossama Mahmoud Bassiouni</td>
                                                    <td>88</td>
                                                    <td>8,00</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        10
                                                        <i className="fas fa-caret-down ml-5 text-danger" />
                                                    </td>
                                                    <td>Shailesh Indapurkar</td>
                                                    <td>70</td>
                                                    <td>7,00</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            }
                            {currenttab == 4 &&
                                <div className="col-12 col-lg-6">
                                    <div className="table-responsive">
                                        <table className="table idea-table font-lato font-12">
                                            <tbody>
                                                <tr>
                                                    <th>Rank</th>
                                                    <th>Name</th>
                                                    <th>Accuracy</th>
                                                    <th>Engagement Score</th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        4<i className="fas fa-caret-up ml-5 text-success" />
                                                    </td>
                                                    <td>Support Services</td>
                                                    <td>83</td>
                                                    <td>15,00</td>
                                                </tr>
                                               
                                      
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            }
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="footer">
                                    <img
                                        src={logo}
                                        className="d-lg-none mb-1"
                                        alt="img"
                                    />
                                    <p className="mb-0">
                                        Copyright © 2010-2022 Protiviti. All rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}